var $ = require('jquery');
var AOS = require('aos');

module.exports = {
	init: function () {
		// Find filter tabs anywhere and attach handlers, but scope actions to the closest listing
		const $filterButtons = $('.resource-filter-btn');

		if ($filterButtons.length === 0) {
			return;
		}

		// Resource listings render these as a tablist (role="tab"); virtual
		// learning renders them as a group of aria-pressed toggle buttons.
		function isTab($button) {
			return $button.attr('role') === 'tab';
		}

		// Select a filter and show its cards. Tabs are never deselected -- a tab
		// with aria-selected can't be toggled off.
		function selectFilter($button, moveFocus) {
			const $listing = $button.closest('.layout.listing');
			const $siblings = $listing.find('.resource-filter-btn');
			const $cards = $listing.find('.card');

			$siblings.removeClass('active');

			if (isTab($button)) {
				// Roving tabindex: only the selected tab is in the tab order, and it
				// carries no tabindex attribute at all.
				$siblings.attr('aria-selected', 'false').attr('tabindex', '-1');
				$button.addClass('active').attr('aria-selected', 'true').removeAttr('tabindex');

				// Each tab owns one panel, so hide every sibling panel and reveal
				// the selected tab's. Inactive panels must be hidden from everyone.
				$siblings.each(function () {
					const siblingPanelId = $(this).attr('aria-controls');

					if (siblingPanelId) {
						$('#' + siblingPanelId).attr('hidden', 'hidden');
					}
				});

				const $panel = $('#' + $button.attr('aria-controls'));
				$panel.removeAttr('hidden');

				announceResults($panel.find('.card').length, $button.text());
			} else {
				$siblings.attr('aria-pressed', 'false');
				$button.addClass('active').attr('aria-pressed', 'true');

				filterCards($cards, $button.data('category'), $button.text());
			}

			if (moveFocus) {
				$button.trigger('focus');
			}

			AOS.refresh(); // Refresh AOS animations after filtering
		}

		// Handle filter tab clicks
		$filterButtons.on('click', function (e) {
			e.preventDefault();
			selectFilter($(this), false);
		});

		// Arrow/Home/End navigation within a tablist, per the ARIA tabs pattern
		$filterButtons.on('keydown', function (e) {
			const $button = $(this);

			if (!isTab($button)) {
				return;
			}

			const $tabs = $button.closest('[role="tablist"]').find('[role="tab"]');
			const current = $tabs.index($button);
			let next;

			switch (e.key) {
			case 'ArrowRight':
				next = (current + 1) % $tabs.length;
				break;
			case 'ArrowLeft':
				next = (current - 1 + $tabs.length) % $tabs.length;
				break;
			case 'Home':
				next = 0;
				break;
			case 'End':
				next = $tabs.length - 1;
				break;
			default:
				return;
			}

			e.preventDefault();
			selectFilter($tabs.eq(next), true);
		});

		// Filter cards function
		function filterCards($cards, categoryId, categoryName) {
			let visibleCount = 0;
			$cards.each(function () {
				const $card = $(this);
				const cardCategories = $card.data('categories');

				if (cardCategories) {
					const categoriesArray = cardCategories
						.toString()
						.split(',')
						.map((id) => parseInt(id));

					if (categoriesArray.includes(parseInt(categoryId))) {
						$card.show();
						visibleCount++;
					} else {
						$card.hide();
					}
				} else {
					$card.hide();
				}
			});

			// Announce results to screen readers
			announceResults(visibleCount, categoryName);
		}

		// Function to announce filter results to screen readers
		function announceResults(count, category) {
			const message =
				count === 1
					? `Showing ${count} resource in ${category}`
					: `Showing ${count} resources in ${category}`;

			// Create or update live region for announcements
			let $liveRegion = $('#resource-filter-announcement');
			if ($liveRegion.length === 0) {
				$liveRegion = $(
					'<div id="resource-filter-announcement" class="sr-only" aria-live="polite" aria-atomic="true"></div>'
				);
				$('body').append($liveRegion);
			}
			$liveRegion.text(message);
		}

		// Trigger filter for first active tab on page load
		// Handle each listing that contains resource filters separately
		$('.layout.listing').each(function () {
			const $listing = $(this);
			const $activeButton = $listing.find('.resource-filter-btn.active').first();

			// Tab panels are rendered in the correct state by PHP, so only the
			// aria-pressed button groups need filtering on load.
			if ($activeButton.length > 0 && !isTab($activeButton)) {
				const categoryId = $activeButton.data('category');
				const $cards = $listing.find('.card');
				filterCards($cards, categoryId, $activeButton.text());
			}
		});
	},
};
